import { ComponentProps } from 'react';
import Erc20Input from './Erc20Input';

type Props = Omit<ComponentProps<typeof Erc20Input>, 'token' | 'type'>;

export default function EthInput(props: Props) {
  return <Erc20Input {...props} token="0x" type="ETH" />;
}
